// The hero film: the cut follows the shape of the box.
//
// <source media> would express this, but a browser evaluates it once at load
// and never again, so a rotation or a resized window keeps the wrong cut.
// matchMedia does re-evaluate.
//
// Nothing here runs if the file cannot play: the <picture> behind it is the
// fallback and simply stays visible.
(function () {
  if (window.__pruvitHero) return;
  window.__pruvitHero = true;

  var STACKED = '(max-width: 940px)';

  function setUp(video) {
    var desktop = video.getAttribute('data-src-desktop');
    var mobile = video.getAttribute('data-src-mobile');
    var query = window.matchMedia(STACKED);

    function choose() {
      // Fall back to whichever cut exists when only one was supplied.
      var wanted = (query.matches ? mobile : desktop) || desktop || mobile;
      if (!wanted || video.getAttribute('src') === wanted) return;
      video.setAttribute('src', wanted);
      var playing = video.play();
      if (playing && typeof playing.catch === 'function') playing.catch(function () {});
    }

    // 'playing', not 'canplay': autoplay can be refused after the file is
    // ready, and the reveal should follow what actually happened.
    video.addEventListener('playing', function () {
      video.classList.add('is-playing');
    });

    choose();
    if (typeof query.addEventListener === 'function') {
      query.addEventListener('change', choose);
    } else if (typeof query.addListener === 'function') {
      query.addListener(choose); // Safari < 14
    }
  }

  function init() {
    document.querySelectorAll('[data-pruvit-hero-video]').forEach(setUp);
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
